<div *ngIf="editForm" class="ir-modal--footer ir-position--b th-modal--footer">
  <div class="ir-row">
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
        <span>{{ 'common.cancel' | translate }}</span>
      </div>
    </div>
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <button
        class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
        type="submit"
        [disabled]="editForm.invalid"
        *ngIf="!processing"
      >
        <span>{{ 'common.save-changes' | translate }}</span>
      </button>
      <button class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right" type="submit" *ngIf="processing">
        <span>{{ 'common.processing' | translate }}</span>
      </button>
    </div>
  </div>
</div>
